/* eslint-disable no-shadow */
/* eslint-disable camelcase */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Button,
  CheckMark,
  focusTrap,
  Icon,
  Loader,
  Modal,
  ReservationSummary,
  Spacer,
  TranslationProvider,
  getTranslation,
  VenueLocationSummary,
} from '@resy/ui-kitchen';
import OnScrollView from '../OnScrollView';
import AnnouncementTile from '../../../../../ui-kitchen/src/components/AnnouncementTile';
import bookingInfoShape from './bookingInfoShape';
import {
  diffDays, getCancelEvent, setToken,
} from './cancelHelpers';
import getHostToken from '../../utils/decline';
import { pastCutoff } from '../../utils/cancel';
import Cancel from '../Cancel';
import Canceled from '../Canceled';
import { getSearchDate } from '../../utils/change';
import Change from '../Change';
import Decline from '../Decline';
import Declined from '../Declined';
import DownloadResy from '../DownloadResy';
import getOrderFromReservation from './getOrderFromReservation';
import modalStyles from '../../constants/modalStyles';
import OrderSummary from '../OrderSummary';
import ReservationQuestionnaire from '../ReservationQuestionnaire';
import reservationShape from './reservationShape';
import SummarySection, {
  SummarySectionBody,
  SummarySectionHeader,
} from '../SummarySection';
import WidgetNav from '../WidgetNav';
import WidgetPage, {
  WidgetPageBody,
  WidgetPageFooter,
  WidgetPageHeader,
} from '../WidgetPage';
import WidgetTitle from '../WidgetTitle';
import { resetReservationToBeModified, setShouldUserReservationsUpdate } from '../../../../../ui-kitchen/src/reducers/userSlice';
import {
  deleteNotifies,
  handleReservationCancel,
  postPartyInviteDecline,
} from '../../../../../ui-kitchen/src/api/api';
import Lock from '../../svg/dynamic/ic_lock_20x20.svg';
import RemoveNotifyList from '../../../../../ui-kitchen/src/components/RemoveNotifyList';
import { setSelectedCoreISODate, setSelectedCoreSeats } from '../../../../../ui-kitchen/src/reducers/resyCoreSlice';
import { setSearchParams } from '../../../../../ui-kitchen/src/utils/searchParamUtils';
import { setRouteEventPath } from '../../../../../ui-kitchen/src/reducers/resyRouterSlice';
import { setBackButton } from '../../../../../ui-kitchen/src/reducers/announcementsSlice';
import { EVENT_TYPE } from '../../../../../ui-kitchen/src/components/Announcement/announcementTypes';
import { RESERVATION_PATH_PLACEMENT } from '../../../../../ui-kitchen/src/constants/bookingFlow';
import AnnouncementCard from '../../../../../ui-kitchen/src/components/AnnouncementCard';
import ResyCreditBanner from '../../../../../ui-kitchen/src/components/ResyCreditBanner';
import { selectExperiment } from '../../../../../ui-kitchen/src/components/Experiments/useExperiment';
import { IS_JCE_BRIDGE_ENABLED, RESY_CREDIT_TEMP_COPY } from '../../../../../ui-kitchen/src/constants/optimizelyExperiments';

import './ConfirmationPage.scss';
import { setBookingFlowState, setNaaAnnouncementThunk, setReservation } from '../../../../../ui-kitchen/src/reducers';
import { getUuid, Logger } from '../../../../../ui-kitchen/src/utils';
import { sanitizeTargetUrl } from '../../../../../ui-kitchen/src/utils/sanitizeTargetUrl';
import OPENAI_WIDGET from '../../constants/srcTypes';

const confirmationPagePropTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  backPath: PropTypes.string.isRequired,
  bookingInfo: bookingInfoShape,
  closeWidget: PropTypes.func,
  closeWindow: PropTypes.func,
  day: PropTypes.string.isRequired,
  experiments: PropTypes.string.isRequired,
  eventPath: PropTypes.string.isRequired,
  flowContext: PropTypes.string,
  isModal: PropTypes.bool,
  locationCode: PropTypes.string,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    ipadLandscape: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  navigate: PropTypes.func.isRequired,
  navSearch: PropTypes.shape({
    seats: PropTypes.string,
    date: PropTypes.string,
  }).isRequired,
  notifies: PropTypes.arrayOf(PropTypes.shape({
    results: PropTypes.shape({
      venues: PropTypes.arrayOf(PropTypes.shape({
        venue: PropTypes.shape({
          location: PropTypes.shape({}),
          name: PropTypes.string,
          responsive_images: PropTypes.shape({}),
        }),
      })),
    }),
    specs: PropTypes.shape({
      service_type_id: PropTypes.number,
      day: PropTypes.string,
      party_size: 7,
      time_preferred_start: PropTypes.string,
      time_preferred_end: PropTypes.string,
      venue_id: PropTypes.number,
    }),
  })),
  pathBuilder: PropTypes.shape({
    backPath: PropTypes.func,
    getSearch: PropTypes.func,
  }),
  preferredLanguage: PropTypes.string.isRequired,
  returnUrl: PropTypes.string,
  reservation: reservationShape,
  resetReservationToBeModified: PropTypes.func.isRequired,
  setRouteEventPath: PropTypes.func.isRequired,
  setSelectedCoreISODate: PropTypes.func.isRequired,
  setSelectedCoreSeats: PropTypes.func.isRequired,
  setShouldUserReservationsUpdate: PropTypes.func.isRequired,
  setNaaAnnouncementThunk: PropTypes.func.isRequired,
  sourceId: PropTypes.string,
  src: PropTypes.string,
  templateAbout: PropTypes.shape({
    body: PropTypes.string,
  }),
  time: PropTypes.string.isRequired,
  viewPortHeight: PropTypes.number,
  offerData: PropTypes.shape({
    header: PropTypes.string,
    image_url: PropTypes.string,
    subheader: PropTypes.string,
    terms_and_fees_url: PropTypes.string,
    action_url: PropTypes.string,
    show_placement: PropTypes.bool,
    tile_term_text: PropTypes.string,
    id: PropTypes.string,
  }).isRequired,
  deviceId: PropTypes.string.isRequired,
  setBackButton: PropTypes.func.isRequired,
  setReservation: PropTypes.func.isRequired,
  setBookingFlowState: PropTypes.func.isRequired,
};

class ConfirmationPage extends React.Component {
  static propTypes = confirmationPagePropTypes;

  static defaultProps = {
    bookingInfo: undefined,
    closeWidget: () => { },
    closeWindow: () => { },
    flowContext: undefined,
    isModal: false,
    locationCode: undefined,
    notifies: undefined,
    pathBuilder: undefined,
    reservation: undefined,
    returnUrl: undefined,
    sourceId: undefined,
    src: 'resy.com',
    templateAbout: undefined,
    viewPortHeight: undefined,
  }

  state = {
    canceled: false,
    declined: false,
    isLoading: false,
    presentCancel: false,
    presentChange: false,
    presentDecline: false,
    presentRemoveNotify: true,
    removeNotifyError: false,
    removeNotifySuccess: false,
    titleOpacity: 0,
  }

  componentDidMount() {
    const {
      reservation,
      setNaaAnnouncementThunk,
      src,
      deviceId,
    } = this.props;

    const [uuid, removeCookieListener] = getUuid(deviceId);

    this.removeCookieListener = removeCookieListener;

    if (!reservation?.event?.name && !reservation?.bookOnBehalf && src !== 'widget') {
      setNaaAnnouncementThunk({ uuid, page: 'reservation_path', location_id: 'ny' });
    }

    this.scrollToTopForOpenAiWidget();
  }

  componentWillUnmount() {
    this.removeCookieListener();
  }

  removeCookieListener = () => { };

  scrollToTopForOpenAiWidget = () => {
    const { sourceId } = this.props;

    if (sourceId !== OPENAI_WIDGET) {
      return;
    }

    const scrollContainer = document.querySelector('.ConfirmationPage__ScrollView');
    if (scrollContainer) {
      scrollContainer.scrollTop = 0;
    }
    window?.scrollTo(0, 0);
  }

  getCancellationPolicy = () => {
    const { bookingInfo, reservation } = this.props;

    if (bookingInfo) {
      const {
        cancellationPolicy,
      } = bookingInfo;

      return cancellationPolicy;
    } if (reservation) {
      const {
        cancellationPolicy,
      } = reservation;

      return cancellationPolicy;
    }

    return false;
  }

  getPastOrFuture = () => {
    const { reservation } = this.props;

    if (reservation) {
      const {
        pastOrFuture,
      } = reservation;
      return pastOrFuture || 'future';
    }

    return 'future';
  }

  getPaymentInfo = () => {
    const { bookingInfo, reservation } = this.props;

    if (reservation) {
      return reservation?.paymentMethod?.last_4;
    } if (bookingInfo) {
      const {
        paymentId,
        reservationDetails: {
          user,
        } = {},
      } = bookingInfo;

      const methods = user && user.payment_methods;
      const payment = methods && methods.find((i) => i.id === paymentId);
      const display = payment && payment.display;
      return display;
    }

    return null;
  }

  getReservationSummaryPropsFromBookingInfo = () => {
    const {
      day,
      bookingInfo: {
        bookOnBehalfOf = {},
        request: {
          partySize,
        } = {},
        reservation: {
          event: {
            name: eventName,
          } = {},
          type,
        } = {},
        venue: {
          images,
          name,
        } = {},
      },
      time,
    } = this.props;

    const { guest_name } = bookOnBehalfOf || {};

    const imageUrl = images && images[0];

    return {
      bookOnBehalfOf: !!bookOnBehalfOf,
      eventName,
      guestName: guest_name,
      imageUrl,
      largeImage: true,
      seats: partySize,
      tableType: type,
      timeslot: {
        day,
        time,
      },
      venue: name,
    };
  }

  getReservationSummaryPropsFromReservation = () => {
    const {
      reservation: {
        bookOnBehalf,
        currencyCode,
        event: {
          name: eventName,
        } = {},
        day,
        isGda,
        payment: {
          invoice: {
            reservation_charge,
          } = {},
        } = {},
        seats,
        tableType,
        time,
        template: {
          images: eventImages,
        },
        venue: {
          images,
          name,
        } = {},
      },
    } = this.props;

    const price = (reservation_charge && reservation_charge / seats) || undefined;

    const eventImage = eventImages && eventImages[0];
    const venueImage = images && images[0];
    const imageUrl = eventImage || venueImage;

    const guestName = bookOnBehalf && bookOnBehalf.name;

    const location = (eventName) ? name : undefined;

    return {
      bookOnBehalfOf: !!guestName,
      currencyCode,
      eventName,
      guestName,
      imageUrl,
      isGda,
      largeImage: true,
      location,
      price,
      seats,
      tableType,
      timeslot: {
        day,
        time,
      },
      venue: name,
    };
  }

  getVenueLocationSummaryPropsFromBookingInfo = () => {
    const {
      Analytics,
      bookingInfo: {
        venue: {
          contact: {
            phone,
            url,
          } = {},
          location,
          name,
          social,
        } = {},
      } = {},
    } = this.props;

    const phoneLabel = phone?.phoneLabel;
    const phoneUrl = phone?.phoneUrl;

    return {
      Analytics,
      location,
      name,
      pageContext: 'confirmation screen',
      phone: {
        phoneLabel,
        phoneUrl,
      },
      social,
      url,
      // eslint-disable-next-line react/destructuring-assignment
      venue: this.props.bookingInfo.venue,
    };
  }

  getVenueLocationSummaryPropsFromReservation = () => {
    const {
      Analytics,
      reservation: {
        venue: {
          contact: {
            phone,
            url,
          } = {},
          location,
          name,
        } = {},
      } = {},
    } = this.props;

    const phoneLabel = phone?.phoneLabel;
    const phoneUrl = phone?.phoneUrl;

    return {
      Analytics,
      location,
      name,
      pageContext: 'confirmation screen',
      phone: {
        phoneLabel,
        phoneUrl,
      },
      url,
      // eslint-disable-next-line react/destructuring-assignment
      venue: this.props.reservation.venue,
    };
  }

  isEvent = () => {
    const { bookingInfo, reservation } = this.props;

    if (reservation) {
      return !!reservation?.event?.eventUrlSlug;
    } if (bookingInfo) {
      return !!bookingInfo?.reservation?.event;
    }

    return false;
  }

  onCancel = async () => {
    const {
      Analytics,
      reservation,
      setShouldUserReservationsUpdate,
    } = this.props;

    const params = setToken(
      reservation.conciergeResyToken,
      reservation.token
    );

    this.onCloseModal();

    this.setState({
      isLoading: true,
    });

    await handleReservationCancel(params);
    try {
      setShouldUserReservationsUpdate({ type: 'upcoming' });

      this.setState({
        canceled: true,
        isLoading: false,
        presentCancel: false,
      });

      /**
         * resy.com won't know that the reservation was cancelled without a refresh,
         * so this is how we will tell it
         * - MY
         */
      if (window.opener) {
        window.opener.postMessage('onResyReservationsSync', '*');
      } else {
        window.parent.postMessage('onResyReservationsSync', '*');
      }

      Analytics.event('cancel booking', getCancelEvent(reservation, diffDays));
    } catch (e) {
      Logger.error(e);
    }
  };

  onCancelNevermind = () => {
    this.onCloseModal();
  }

  onCancelPresent = () => {
    this.setState({
      presentCancel: true,
    });
  }

  onChange = () => {
    const { reservation } = this.props;

    // need present modal possibility here.
    if (
      reservation.change?.allowed === false
      || (reservation.change?.date_cut_off !== null
        && pastCutoff(reservation.change?.date_cut_off))
    ) {
      this.setState({ presentChange: true });
      return;
    }

    this.onChangeReservation();
  }

  onChangeReservation = () => {
    const {
      eventPath, navigate, reservation, setRouteEventPath, setSelectedCoreISODate, setSelectedCoreSeats,
    } = this.props;
    let path = `/venues/${reservation?.venue?.id}`;
    if (eventPath) {
      if (this.isEvent()) {
        path = eventPath;
      } else {
        // in a state where eventPath is stale and needs to be cleared
        setRouteEventPath('');
      }
    }
    const date = getSearchDate(reservation);
    setSelectedCoreISODate(date);
    setSelectedCoreSeats(reservation?.seats);
    navigate(path);
    setSearchParams('date', date);
    setSearchParams('seats', reservation?.seats);
    setSearchParams('resyToken', reservation?.token);
    setSearchParams('cancel', true);
  }

  onClose = () => {
    const { closeWidget, closeWindow, isModal } = this.props;
    if (isModal) {
      closeWidget();
      return;
    }
    closeWindow();
  }

  onCloseModal = () => {
    this.setState({
      presentCancel: false,
      presentChange: false,
      presentDecline: false,
    });
  }

  onCancelledConfirmationClose = () => {
    const { resetReservationToBeModified } = this.props;
    this.setState({ canceled: false });
    resetReservationToBeModified();
    this.onDone();
  }

  onDone = () => {
    const { returnUrl } = this.props;

    if (returnUrl) {
      const sanitizedReturnUrl = sanitizeTargetUrl(returnUrl);
      if (sanitizedReturnUrl && sanitizedReturnUrl !== 'about:blank') {
        window.location.assign(sanitizedReturnUrl);
        return;
      }
    }

    this.onClose();
  }

  onRemoveGuest = () => {
    this.setState({ presentDecline: true });
  }

  removeGuest = () => {
    const {
      reservation,
    } = this.props;
    try {
      postPartyInviteDecline(getHostToken(reservation)).then(
        () => {
          this.onCloseModal();
          this.setState({
            declined: true,
            presentDecline: false,
          });
        }
      );
    } catch (error) {
      Logger.error(`[UserInvite] error removing from reservation: ${error?.data?.message}`);
    }
  }

  handleCloseRemoveNotifyModal = () => {
    this.setState({ presentRemoveNotify: false });
  }

  removeNotifies = async () => {
    const { notifies } = this.props;

    try {
      await deleteNotifies({
        service_type_id: notifies[0].specs.service_type_id,
        date: notifies[0].specs.day,
      });
      this.setState({
        removeNotifySuccess: true,
        removeNotifyError: false,
      }, () => {
        setTimeout(() => {
          this.setState({
            presentRemoveNotify: false,
          });
        }, 1000);
      });
    } catch (error) {
      this.setState({ removeNotifyError: true });
    }
  }

  renderRemoveNotifyModal = () => {
    const {
      day,
      notifies,
    } = this.props;

    const {
      presentRemoveNotify,
      removeNotifyError,
      removeNotifySuccess,
    } = this.state;

    if (!presentRemoveNotify || !notifies || notifies?.length === 0) {
      return null;
    }

    return (
      <RemoveNotifyList
        isError={removeNotifyError}
        isSuccessful={removeNotifySuccess}
        notifies={notifies}
        onCloseModal={this.handleCloseRemoveNotifyModal}
        removeNotifies={this.removeNotifies}
        selectedDate={day}
      />
    );
  }

  renderAbout = () => {
    if (this.isEvent()) {
      return null;
    }

    const {
      bookingInfo: {
        venue: {
          content,
        } = {},
      } = {},
    } = this.props;

    const about = content && content.find((o) => o.name === 'about');

    if (!about) {
      return null;
    }

    return (
      <>
        <SummarySection>
          <SummarySectionHeader>
            <TranslationProvider translationKey="about_header">
              <span>About</span>
            </TranslationProvider>
          </SummarySectionHeader>
          <SummarySectionBody>
            {about.body}
          </SummarySectionBody>
        </SummarySection>
        <Spacer height="30" />
      </>
    );
  }

  renderCancel = () => {
    const { reservation } = this.props;

    return (
      <Cancel
        cancelClick={this.onCancelNevermind}
        cancelCtaKey="abort_cancellation_button"
        cancelCtaText="Nevermind"
        confirmClick={this.onCancel}
        confirmCtaKey="cancel_reservation_confirm_button"
        confirmCtaText="Yes, cancel"
        reservation={reservation}
      />
    );
  }

  renderCancelChange = () => {
    const { reservation, sourceId } = this.props;

    if (!reservation) {
      return null;
    }

    const isBookOnBehalf = reservation?.bookOnBehalf;
    const isOpenAiWidget = sourceId === OPENAI_WIDGET;

    if (this.getPastOrFuture() === 'past' || isOpenAiWidget) {
      return null;
    }

    return (
      <>
        {!isBookOnBehalf && (
          <Button
            className="ConfirmationPage__change"
            onClick={this.onChange}
            sm
            data-test-id="confirmation_summary_page-button-change"
            variant="secondary"
          >
            <TranslationProvider translationKey="button_change_reservation">
              <span>Change Reservation</span>
            </TranslationProvider>
          </Button>
        )}
        <Button
          className="ConfirmationPage__cancel"
          onClick={this.onCancelPresent}
          sm
          data-test-id="confirmation_summary_page-button-cancel"
          variant="cancel"
        >
          <TranslationProvider translationKey="button_cancel">
            <span>Cancel</span>
          </TranslationProvider>
        </Button>
      </>
    );
  }

  renderCanceled = () => {
    const { Analytics, pathBuilder, reservation } = this.props;

    const search = pathBuilder.getSearch();

    return (
      <Canceled
        Analytics={Analytics}
        link={`#${pathBuilder.backPath()}?seats=${search?.seats}&date=${search?.date}`}
        reservation={reservation}
        escHandler={this.onCancelledConfirmationClose}
      />
    );
  }

  renderDeclined = () => (
    <Declined />
  );

  renderCancellationPolicy = () => {
    const policy = this.getCancellationPolicy();

    const {
      reservation,
    } = this.props;

    if (reservation?.attendee?.type === 'guest') {
      return null;
    }

    if (policy && policy.length) {
      return (
        <>
          <SummarySection>
            <SummarySectionHeader>
              <TranslationProvider translationKey="cancellation_policy_header">
                <span>Cancellation Policy</span>
              </TranslationProvider>
            </SummarySectionHeader>
            <SummarySectionBody className="ConfirmationPage__cancellation">
              <ul>
                {policy.map((p) => <li key={p.substring(0, 9)}>{p}</li>)}
              </ul>
              {this.renderCancelChange()}
            </SummarySectionBody>
          </SummarySection>
          <Spacer height="30" />
        </>
      );
    }

    return null;
  }

  renderResyCreditBanner = () => {
    const { experiments, reservation } = this.props;
    const isResyCreditEligible = reservation?.venue?.isResyCreditEligible;
    const { enabled: isResyCreditBannerEnabled } = selectExperiment(
      { experiments },
      IS_JCE_BRIDGE_ENABLED
    );
    const { enabled: isResyCreditTempCopyEnabled } = selectExperiment(
      { experiments },
      RESY_CREDIT_TEMP_COPY
    );

    if (!isResyCreditBannerEnabled) {
      return null;
    }

    return (
      <>
        <SummarySection>
          <SummarySectionHeader>
            <span>
              {isResyCreditEligible ? (
                <>
                  <TranslationProvider translationKey="resy_credit_banner_header_eligible">
                    <span>Qualifies for Resy Credit</span>
                  </TranslationProvider>
                  {' '}
                  <CheckMark className="ConfirmationPage__resy-credit-checkmark" />
                </>
              ) : (
                <TranslationProvider translationKey="resy_credit_banner_header_ineligible">
                  <span>Resy Credit</span>
                </TranslationProvider>
              )}
            </span>
          </SummarySectionHeader>
          <SummarySectionBody>
            <ResyCreditBanner
              hideTitle
              isResyCreditEligible={isResyCreditEligible}
              useTempCopy={isResyCreditTempCopyEnabled}
            />
          </SummarySectionBody>
        </SummarySection>
        <Spacer height="30" />
      </>
    );
  }

  renderChange = () => {
    const { reservation } = this.props;

    return (
      <Change
        confirmClick={this.onCloseModal}
        reservation={reservation}
      />
    );
  }

  renderDecline = () => (
    <Decline
      cancelClick={this.onCloseModal}
      confirmClick={this.removeGuest}
    />
  );

  renderDone = () => {
    const {
      reservation: {
        isGda,
      } = {},
    } = this.props;

    return (
      <Button
        className="ConfirmationPage__done"
        data-test-id="confirmation_summary_page-button-done"
        lg
        onClick={this.onDone}
        variant={isGda ? 'rga' : 'primary'}
      >
        <TranslationProvider translationKey="button_done">
          <span>Done</span>
        </TranslationProvider>
      </Button>
    );
  }

  renderDownloadResy = () => {
    const { preferredLanguage, src, sourceId } = this.props;

    return (
      <DownloadResy
        src={src}
        language={preferredLanguage}
        sourceId={sourceId}
      />
    );
  }

  renderIncludedWithTicket = () => {
    const {
      reservation: {
        features: whatsIncluded,
      } = {},
    } = this.props;

    if (!whatsIncluded || !whatsIncluded.length) {
      return null;
    }

    return (
      <>
        <SummarySection>
          <SummarySectionHeader>
            <TranslationProvider translationKey="included_with_ticket">
              <span>Included With This Ticket</span>
            </TranslationProvider>
          </SummarySectionHeader>
          <SummarySectionBody>
            <ul className="SummaryPage__MenuHighlights">
              {
                whatsIncluded.map(
                  (val) => <li key={val}>{val}</li>
                )
              }
            </ul>
          </SummarySectionBody>
        </SummarySection>
        <Spacer height="30" />
      </>
    );
  }

  renderLoader = () => {
    const { isLoading } = this.state;
    if (!isLoading) {
      return null;
    }

    return <Loader />;
  }

  renderModal = () => {
    const {
      presentCancel,
      presentChange,
      presentDecline,
    } = this.state;

    if (!presentCancel && !presentChange && !presentDecline) {
      return null;
    }

    const customStyles = {
      ...modalStyles,
      content: {
        top: '150px',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, 0%)',
        maxWidth: '400px',
      },
    };

    setTimeout(() => {
      document.querySelector('.WidgetNav').scrollIntoView(true);
    }, 10);
    return (
      <Modal
        isOpen
        style={customStyles}
        onAfterClose={focusTrap.focusPage}
        onAfterOpen={focusTrap.focusModal}
      >
        {presentCancel && this.renderCancel()}
        {presentChange && this.renderChange()}
        {presentDecline && this.renderDecline()}
      </Modal>
    );
  }

  renderNeedToKnow = () => {
    const {
      reservation,
    } = this.props;

    const needToKnow = reservation?.content?.find(
      (obj) => obj.name === 'need_to_know'
    );

    if (!needToKnow || !needToKnow.body || needToKnow.body.length === 0) {
      return null;
    }

    if (reservation?.attendee?.type === 'guest') {
      return null;
    }

    return (
      <>
        <SummarySection>
          <SummarySectionHeader>
            <TranslationProvider translationKey="need_to_know_header">
              <span>Need to Know</span>
            </TranslationProvider>
          </SummarySectionHeader>
          <SummarySectionBody>
            {needToKnow.body}
          </SummarySectionBody>
        </SummarySection>
        <Spacer height="30" />
      </>
    );
  }

  renderOrderSummary = () => {
    const {
      preferredLanguage, reservation,
    } = this.props;

    if (!reservation) {
      return null;
    }

    if (reservation?.attendee?.type === 'guest') {
      return null;
    }

    const orderFromReservation = getOrderFromReservation(reservation);

    if (!orderFromReservation) {
      return null;
    }

    const order = {
      ...orderFromReservation,
      isUSLocation: reservation.venue.isUSLocation,
      locale: preferredLanguage,
      taxIncluded: reservation.venue.taxIncluded,
    };

    return (
      <>
        <SummarySection>
          <SummarySectionHeader>
            <TranslationProvider translationKey="order_summary">
              <span>Order Summary</span>
            </TranslationProvider>
          </SummarySectionHeader>
          <SummarySectionBody>
            <OrderSummary {...order} />
          </SummarySectionBody>
        </SummarySection>
        <Spacer height="30" />
      </>
    );
  }

  renderPayment = () => {
    const {
      reservation,
    } = this.props;

    if (reservation?.attendee?.type === 'guest') {
      return null;
    }

    const info = this.renderPaymentInfo(
      this.getPaymentInfo()
    );

    if (!info) {
      return null;
    }

    return (
      <>
        <SummarySection>
          <SummarySectionHeader>
            <div className="ConfirmationPage__payment">
              <TranslationProvider translationKey="payment_method_header">
                <span>Payment Method</span>
              </TranslationProvider>
              <Icon component={Lock} name="lock" />
            </div>
          </SummarySectionHeader>
          <SummarySectionBody className="ReservationSummaryPage__payment">
            {info}
          </SummarySectionBody>
        </SummarySection>
        <Spacer height="30" />
      </>
    );
  }

  renderPaymentInfo = (display) => {
    if (!display) {
      return null;
    }

    return (
      <TranslationProvider translationKey="card_ending_in" translationValues={{ cardNumber: display }}>
        <span>{`Card ending in ${display}`}</span>
      </TranslationProvider>
    );
  };

  renderReservationSummary = () => {
    const {
      bookingInfo,
      reservation,
    } = this.props;

    if (!bookingInfo && !reservation) {
      return null;
    }

    const props = bookingInfo ? this.getReservationSummaryPropsFromBookingInfo() : this.getReservationSummaryPropsFromReservation();

    const handleReservationSummaryTitleClick = () => {
      const locationSlug = reservation?.venue?.location?.urlSlug;
      const venueSlug = reservation?.venue?.venueSlug;

      const { eventUrlSlug } = reservation.event;
      window.parent.postMessage({
        event: 'onWindowOpenRequest',
        url: (eventUrlSlug)
          ? `/cities/${locationSlug}/venues/${venueSlug}/events/${eventUrlSlug}`
          : `/cities/${locationSlug}/venues/${venueSlug}`,
        target: '_blank',
      }, '*');
    };

    return (
      <ReservationSummary {...props} onVenueTitleClick={handleReservationSummaryTitleClick} />
    );
  }

  renderVenueLocationSummary = () => {
    const {
      bookingInfo,
      reservation,
    } = this.props;

    if (!bookingInfo && !reservation) {
      return null;
    }

    const props = bookingInfo ? this.getVenueLocationSummaryPropsFromBookingInfo() : this.getVenueLocationSummaryPropsFromReservation();

    return (
      <VenueLocationSummary {...props} />
    );
  }

  renderReservationQuestionnaire = () => {
    const {
      Analytics,
      reservation,
    } = this.props;

    return (
      <ReservationQuestionnaire
        Analytics={Analytics}
        reservation={reservation}
        onClose={this.onClose}
      />
    );
  }

  renderWidgetTitle = () => {
    const {
      reservation,
    } = this.props;

    if (!reservation) {
      return null;
    }

    const key = 'reservation_header';
    const fallback = 'Reservation Booked.';

    return (
      <WidgetTitle role="alert">
        <div className="ConfirmationPage__header">
          <TranslationProvider translationKey={key}>
            <span>{fallback}</span>
          </TranslationProvider>
          <Icon component={CheckMark} name="check" />
        </div>
        <TranslationProvider translationKey="confirmation_check_inbox">
          <div className="WidgetTitle__subHeading">Please check your inbox for a confirmation email.</div>
        </TranslationProvider>
      </WidgetTitle>
    );
  }

  renderAnnouncementTile = () => {
    const {
      Analytics,
      flowContext,
      locationCode,
      matchMedia,
      deviceId,
    } = this.props;
    if (!(flowContext && locationCode)) {
      return null;
    }
    return (
      <AnnouncementTile
        Analytics={Analytics}
        flowContext={flowContext}
        locationCode={locationCode}
        matchMedia={matchMedia}
        deviceId={deviceId}
      />
    );
  }

  renderConfirmationNaaTile = () => {
    const {
      Analytics,
      offerData,
      reservation,
      setBackButton,
      setReservation,
      setBookingFlowState,
    } = this.props;

    const {
      image_url, subheader, header, tile_term_text, id,
    } = offerData;

    const onClickCTA = () => {
      setBackButton(true);
      setReservation(reservation);
      Analytics.event(EVENT_TYPE.VIEW_ANNOUNCEMENT, {
        context: 'reservation path',
        type: 'tile',
        title: header,
        id,
      });
      setBookingFlowState(RESERVATION_PATH_PLACEMENT);
    };
    return (
      <AnnouncementCard
        imageUrl={image_url}
        subheader={subheader}
        header={header}
        tileTermText={tile_term_text}
        onClickCTA={onClickCTA}
      />
    );
  }

  scrollFunc = (elems, scrollTop) => {
    const diffWithScrollTop = (elems[0].offsetTop + elems[0].offsetHeight) - scrollTop;
    const perc = 1 - diffWithScrollTop / elems[0].offsetHeight;

    this.setState({
      titleOpacity: (perc <= 0) ? 0 : 1,
    });
  }

  getScrollEvents = () => [
    {
      selector: ['.WidgetPageHeader'],
      func: this.scrollFunc,
    },
  ];

  renderWidgetNav = () => {
    const {
      Analytics,
      backPath,
      navigate,
      navSearch,
    } = this.props;

    const { titleOpacity } = this.state;

    const title = getTranslation(
      {
        translationKey: 'reservation_header',
        fallback: 'Reservation Booked.',
      }
    );

    return (
      <WidgetNav
        Analytics={Analytics}
        backPath={backPath}
        navigate={navigate}
        pageContext="confirmation screen"
        showBack
        showProfileMenu
        search={navSearch}
        title={title}
        titleOpacity={titleOpacity}
      />
    );
  }

  render() {
    const {
      canceled,
      declined,
    } = this.state;

    if (canceled) {
      return this.renderCanceled();
    }

    if (declined) {
      return this.renderDeclined();
    }

    const {
      viewPortHeight, offerData, reservation, sourceId,
    } = this.props;
    const shouldRenderConfirmationNaa = offerData && !reservation?.event?.name && !reservation?.bookOnBehalf;

    return (
      <WidgetPage className="ConfirmationPage" height={viewPortHeight} ariaLabel={getTranslation({ translationKey: 'reservation_header', fallback: 'Reservation Booked.' })}>
        {this.renderModal()}
        {this.renderRemoveNotifyModal()}
        {this.renderWidgetNav()}
        <OnScrollView className="ConfirmationPage__ScrollView" scrollEvents={this.getScrollEvents()}>
          <WidgetPageHeader>
            {this.renderWidgetTitle()}
            {this.renderReservationSummary()}
          </WidgetPageHeader>
          <WidgetPageBody>
            {this.renderLoader()}
            {this.renderAbout()}
            {this.renderReservationQuestionnaire()}
            {shouldRenderConfirmationNaa ? this.renderConfirmationNaaTile() : this.renderAnnouncementTile()}
            {this.renderOrderSummary()}
            {this.renderPayment()}
            {this.renderNeedToKnow()}
            {this.renderCancellationPolicy()}
            {this.renderResyCreditBanner()}
            {this.renderIncludedWithTicket()}
            {this.renderVenueLocationSummary()}
            <Spacer height={20} />
            {this.renderDownloadResy()}
            {sourceId === OPENAI_WIDGET && <Spacer height="80" />}
          </WidgetPageBody>
          <WidgetPageFooter>
            {this.renderDone()}
          </WidgetPageFooter>
        </OnScrollView>
      </WidgetPage>
    );
  }
}

const mapStateToProps = ({
  matchMedia, resyLocations, resyRouter, naaAnnouncement, resyConfig, experiments,
}) => ({
  backPath: resyRouter.backPath,
  eventPath: resyRouter.eventPath,
  locationCode: resyLocations.selected?.code,
  matchMedia,
  navSearch: resyRouter.search,
  sourceId: resyRouter.sourceId,
  offerData: naaAnnouncement.offerData,
  deviceId: resyConfig.deviceId,
  experiments,
});
const mapDispatchToProps = {
  resetReservationToBeModified,
  setRouteEventPath,
  setShouldUserReservationsUpdate,
  setSelectedCoreISODate,
  setSelectedCoreSeats,
  setNaaAnnouncementThunk,
  setBackButton,
  setReservation,
  setBookingFlowState,
};

export { confirmationPagePropTypes, ConfirmationPage as ComponentUnderTest };
export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationPage);
